import { render, staticRenderFns } from "./textarea-cmp-extended.vue?vue&type=template&id=f22c8f00&scoped=true"
import script from "./textarea-cmp-extended.vue?vue&type=script&lang=js"
export * from "./textarea-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./textarea-cmp-extended.vue?vue&type=style&index=0&id=f22c8f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c8f00",
  null
  
)

export default component.exports